import { createCurrentWallet as coreCreateCurrentWallet } from '@web3-wallet/core';
import { useEffect, useRef, useState } from 'react';
import { createWallet } from './createWallet';
export const createCurrentWallet = (connectorsOrWallets, options) => {
    const coreCurrentWallet = coreCreateCurrentWallet(connectorsOrWallets, options);
    const { useHasProvider: _, ...currentWallet } = createWallet(coreCurrentWallet);
    const useWalletName = () => currentWallet.getStore()((s) => s.walletName);
    const useConnectionStatus = () => currentWallet.getStore()((s) => s.connectionStatus);
    const useHasProvider = (...args) => {
        const [hasProvider, setHasProvider] = useState(false);
        const walletName = useWalletName();
        const argsRef = useRef(args);
        argsRef.current = args;
        useEffect(() => {
            let canceled = false;
            currentWallet
                .getConnector()
                .detectProvider(...argsRef.current)
                .then(() => {
                if (!canceled)
                    setHasProvider(true);
            })
                .catch(() => {
                if (!canceled)
                    setHasProvider(false);
            });
            return () => {
                canceled = true;
            };
        }, [walletName]);
        return hasProvider;
    };
    return {
        ...currentWallet,
        useHasProvider,
        useWalletName,
        useConnectionStatus,
    };
};
